var React = require('react');

function LogoMagentaOmg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#f0f","fillRule":"nonzero","d":"M13.868 69.484H.173V.934h4.54v64.082h9.155v4.468z","key":0}),React.createElement("ellipse",{"cx":"806.115","cy":"665.987","fill":"none","stroke":"#f0f","strokeWidth":"43.41","rx":"119.236","ry":"116.178","transform":"matrix(.09215 0 0 .09215 -48.636 5.885)","key":1}),React.createElement("path",{"fill":"#f0f","fillRule":"nonzero","d":"M13.4 35.017V1.105h24.533v4.026H17.9v10.373h18.756v3.978H17.899V31.04H38.69v3.978H13.4z","key":2}),React.createElement("path",{"fill":"#f0f","d":"M13.293 42.32h25.452v4.032H13.293z","key":3})]);
}

LogoMagentaOmg.defaultProps = {"fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"1.5","clipRule":"evenodd","viewBox":"0 0 39 80"};

module.exports = LogoMagentaOmg;

LogoMagentaOmg.default = LogoMagentaOmg;
